import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Prevent zoom on iOS when focusing inputs
document.addEventListener('touchstart', {}, true);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // Removed React.StrictMode to prevent double API calls in production
  // React.StrictMode causes useEffect to run twice in development
  <App />
)
